<template>
  <public-layout>
    <div class="add-member">
      <h1 v-bg-typography="'h1'">Verify Account</h1>
      <ValidationObserver ref="observer">
        <form v-on:submit.prevent="addNewMember" class="signin">
          <ValidationProvider
            ref="email"
            rules="required"
            v-slot="{ errors, valid, changed }"
          >
            <bg-field
              :error="errors && errors[0]"
              label="First name"
              name="first_name"
            >
              <bg-input
                :error="errors && errors[0]"
                name="first_name"
                :valid="changed && valid"
                v-model="user.first_name"
              />
            </bg-field>
          </ValidationProvider>
          <ValidationProvider
            ref="email"
            rules="required"
            v-slot="{ errors, valid, changed }"
          >
            <bg-field
              :error="errors && errors[0]"
              label="Last name"
              name="last_name"
            >
              <bg-input
                :error="errors && errors[0]"
                name="last_name"
                :valid="changed && valid"
                v-model="user.last_name"
              />
            </bg-field>
          </ValidationProvider>
          <ValidationProvider
            rules="required|min:6"
            vid="confirmation"
            v-slot="{ errors, valid, changed }"
          >
            <bg-field
              label="Password"
              :error="errors && errors[0]"
              name="password"
            >
              <bg-input
                v-model="user.password"
                :error="errors && errors[0]"
                :valid="changed && valid"
                type="password"
              />
            </bg-field>
          </ValidationProvider>
          <ValidationProvider
            rules="required|password:confirmation"
            v-slot="{ errors, valid, changed }"
          >
            <bg-field
              :error="errors && errors[0]"
              label="Re-enter password"
              name="password"
            >
              <bg-input
                :error="errors && errors[0]"
                :valid="changed && valid"
                v-model="user.password2"
                type="password"
              />
            </bg-field>
          </ValidationProvider>
          <bg-button
            text="Verify Account"
            type="submit"
            :isLoading="isPosting"
          />
          <bg-error :error="error" />
        </form>
      </ValidationObserver>
    </div>
  </public-layout>
</template>

<style scoped>
.account {
  display: flex;
  justify-content: space-between;
}
.display {
  display: none;
}

.signin {
  max-width: 600px;
}
</style>

<script>
import PublicLayout from "@/layouts/public";
import BgField from "@/components/bg-field";
import BgTypography from "@/directives/bg-typography";
import BgInput from "@/components/bg-input";
import BgButton from "@/components/bg-button";
import BgError from "@/components/bg-error";
import BgSelect from "@/components/bg-select";

import API from "@/api";

export default {
  name: "account",
  components: {
    BgButton,
    BgError,
    PublicLayout,
    BgField,
    BgInput,
    BgSelect,
  },
  directives: {
    BgTypography,
  },
  data() {
    return {
      error: null,
      isPosting: false,
      user: {
        first_name: "",
        last_name: "",
        email: "",
        company_id: "",
      },
    };
  },
  methods: {
    async addNewMember() {
      const res = await this.$refs.observer.validate();
      if (res) {
        this.isPosting = true;
        const payload = {
          password: this.user.password,
          profile: {
            first_name: this.user.first_name,
            last_name: this.user.last_name,
          },
        };

        const res = await API.user.confirm(
          this.$route.query.confirmation_token,
          payload
        );
        if (res.errors) {
          this.isPosting = false;
        } else {
          this.$router.push({ path: `/signup` });
        }
      }
    },
  },
};
</script>
